import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-service-agreement-sent-page',
  templateUrl: './service-agreement-sent-page.component.html',
  styleUrls: ['./service-agreement-sent-page.component.scss']
})
export class ServiceAgreementSentPageComponent  {
  constructor(private location: Location) { }

  back() {
    this.location.back();
  }
}
